/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable default-case */
// import { Layout } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form, Input, Divider, Typography, Modal, Row, Col, DatePicker, Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import { SafetyCertificateOutlined, SaveOutlined } from '@ant-design/icons';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import moment from 'moment';
import ProcessingModal from '../../components/processing/ProcessingModal';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import '../common/BraineeModule.css';
import './StudentEmergencyInfo.css';


const { Title, Text } = Typography;

export function StudentEmergencyInfo(props) {
   const [form] = Form.useForm();

   const [user_id] = useState(Utils.getCurrentUserInfo(Enums.UserInfo.id));

   const [studentInfo, setStudentInfo] = useState(null);
   const [oaData, setOAData] = useState(null);
   const [emergencyInfo, setEmergencyInfo] = useState(null);
   const [modalDisclaimer, setModalDisclaimer] = useState(false);

   const [formValues, setFormValues] = useState(null);
   const [updating, setUpdating] = useState(false);

   // const [disabled] = useState(props.mode !== undefined ? props.mode === 'edit' ? false : true : false)
   const [disabled] = useState(props.mode === 'view' ? true : false)
   const isEmbedded = props.student_id !== undefined;
   const currentModeLabel = disabled ? 'View only' : 'Editable';

   useEffect(() => {
      getAllData(props.student_id !== undefined ? props.student_id : user_id);
   }, []);

   const getAllData = async (userid) => {
      try {
         const [studentprofile, oa] = await Promise.all([
            axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/getstudentprofile?id=${userid}`),
            axios.get(`${process.env.REACT_APP_API_CPH}/getoadata`),
         ]);

         setOAData({
            school_name: oa.data.school_name !== null && oa.data.school_name !== undefined ? oa.data.school_name : null,
         });
         setEmergencyInfo(studentprofile.data.emergency_info !== null && studentprofile.data.emergency_info !== '' ? JSON.parse(studentprofile.data.emergency_info) : null);
         setStudentInfo(studentprofile.data);
      } catch (error) {
         console.error("Error fetching data in getAllData:", error);
         Modal.error({
            title: "Data Fetch Error",
            content: error.response?.data?.message || error.message || "An error occurred while fetching student or emergency info.",
            centered: true,
         });
      }
   }

   const onFinish = (values) => {
      // setModalSubmit(true);
      // setFormValues(values);
      console.log('Finished!');
   };

   const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo);
   };

   const DoSaveInfo = async () => {
      setUpdating(true);
      try {
         const formData = form.getFieldsValue(true);

         const emergencyData = {
            full_name: formData.full_name,
            grade_section: formData.grade_section,
            birth_date: moment(formData.birth_date).format('YYYY-MM-DD'),
            address: formData.address,
            home_phone: formData.home_phone,
            student_mobile: formData.student_mobile,
            fathers_name: formData.fathers_name,
            fathers_mobile: formData.fathers_mobile,
            fathers_email_add: formData.fathers_email_add,
            mothers_name: formData.mothers_name,
            mothers_mobile: formData.mothers_mobile,
            mothers_email_add: formData.mothers_email_add,
            legal_guardian_name: formData.legal_guardian_name,
            legal_guardian_relationship: formData.legal_guardian_relationship,
            legal_guardian_mobile_no: formData.legal_guardian_mobile_no,
            legal_guardian_email: formData.legal_guardian_email,
            autorized_person_1: formData.autorized_person_1,
            autorized_person_1_relationship: formData.autorized_person_1_relationship,
            autorized_person_1_contact_no: formData.autorized_person_1_contact_no,
            autorized_person_2: formData.autorized_person_2,
            autorized_person_2_relationship: formData.autorized_person_2_relationship,
            autorized_person_2_contact_no: formData.autorized_person_2_contact_no,
            autorized_person_3: formData.autorized_person_3,
            autorized_person_3_relationship: formData.autorized_person_3_relationship,
            autorized_person_3_contact_no: formData.autorized_person_3_contact_no,
            allergies: formData.allergies,
            medical_conditions: formData.medical_conditions,
            medications: formData.medications,
            emergency_contact_name: formData.emergency_contact_name,
            emergency_contact_relationship: formData.emergency_contact_relationship,
            emergency_contact_number: formData.emergency_contact_number
         };

         const { data: result, status } = await axios.post(`${process.env.REACT_APP_API_MANAGEMENT}/updateemergencyinfo?id=${props.student_id !== undefined ? props.student_id : user_id}`, emergencyData);

         if (status === 200) {
            Modal.success({
               title: 'Emergency Information',
               content: 'Information posted.',
               centered: true,
            });
         } else {
            throw new Error(`Unexpected response: ${status}`);
         }
      } catch (error) {
         console.error('Error saving Emergency Information:', error.message);
         Modal.error({
            title: 'Emergency Information',
            content: error.response?.data || 'It seems that there was a problem encountered while processing your request.',
            centered: true,
         });
      } finally {
         setUpdating(false);
      }
   };

   const handleSubmit = () => {
      form.validateFields().then(() => {
         DoSaveInfo();
      }).catch((error) => {
         console.log('Validation Error:', error);
         Modal.info({
            title: 'Online Application',
            content: 'Please fill out all required fields.',
            centered: true
         });
      });
   }

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div className={`dashboard-area-all brainee-module-page emergency-info-page${isEmbedded ? ' is-embedded' : ''}`}>
            <div className="dashboard-item brainee-module-shell emergency-info-shell">
               {!isEmbedded && (
                  <div className="brainee-module-breadcrumb">
                     <ResponsiveBreadcrumb
                        items={[
                           { key: 'home', node: <Link to="/home">Home</Link> },
                           { key: 'emergency-info', node: 'Emergency Information' },
                        ]}
                     />
                  </div>
               )}

               {studentInfo === null ? (
                  <section className="brainee-module-panel emergency-info-loading">
                     <Skeleton active paragraph={{ rows: 8 }} />
                  </section>
               ) : (
                  <>
                     <section className="brainee-module-hero emergency-info-hero">
                        <div>
                           <Text className="brainee-module-kicker">Emergency Information</Text>
                           <h1>Student Emergency Sheet</h1>
                           <p>
                              Keep the learner's contact, guardian, pick-up, and medical information ready for safety and emergency response.
                           </p>
                           <div className="brainee-module-meta">
                              <span>{studentInfo.full_name || 'Student profile'}</span>
                              <span>{studentInfo.grade_section || 'Grade and section pending'}</span>
                              <span>{currentModeLabel}</span>
                           </div>
                        </div>
                        <div className="emergency-info-hero-icon" aria-hidden="true">
                           <SafetyCertificateOutlined />
                        </div>
                     </section>

                     <section className="brainee-module-panel emergency-info-form-panel">
                     <Form
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        layout='vertical'
                        className="emergency-info-form"
                     >
                        <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                           <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>STUDENT INFORMATION</Title>
                        </Divider>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={24} lg={24}>
                              <Form.Item
                                 name={'full_name'}
                                 label="Full Name"
                                 rules={[{ required: disabled ? false : true, message: 'Full Name is required' }]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo === null ? studentInfo.full_name : emergencyInfo.full_name}
                              >
                                 <Input id={'full_name'} name={'full_name'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>
                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={12} lg={12}>
                              <Form.Item
                                 name={'grade_section'}
                                 label="Grade & Section"
                                 rules={[{ required: disabled ? false : true, message: 'Grade & Section is required' },]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo === null ? studentInfo.grade_section : emergencyInfo.grade_section}
                              >
                                 <Input id={'grade_section'} name={'grade_section'} style={{ borderRadius: '7px' }} disabled />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={12} lg={12}>
                              <Form.Item
                                 name={'birth_date'}
                                 label="Birth Date"
                                 rules={[{ required: disabled ? false : true, message: 'Birth Date is required' },]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo === null ? moment(studentInfo.date_of_birth) : moment(emergencyInfo.birth_date)}
                              >
                                 <DatePicker
                                    id={'birth_date'}
                                    name={'birth_date'}
                                    style={{ width: "100%" }}
                                    format={'MMMM D, YYYY'}
                                    disabled={disabled}
                                 />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={24} lg={24}>
                              <Form.Item
                                 name={'address'}
                                 label="Address"
                                 rules={[{ required: disabled ? false : true, message: 'Address is required' },]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.address : null}
                              >
                                 <Input id={'address'} name={'address'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={12} lg={12}>
                              <Form.Item
                                 name={'home_phone'}
                                 label="Home Telephone No."
                                 rules={[{ required: disabled ? false : true, message: 'Home Telephone is required' },]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.home_phone : null}
                              >
                                 <Input id={'home_phone'} name={'home_phone'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={12} lg={12}>
                              <Form.Item
                                 name={'student_mobile'}
                                 label="Student's Mobile No.(if applicable)"
                                 rules={[
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid mobile number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo === null ? studentInfo.student_mobile : emergencyInfo.student_mobile}
                              >
                                 <Input id={'student_mobile'} name={'student_mobile'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                           <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>PARENT/GUARDIAN INFORMATION</Title>
                        </Divider>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'fathers_name'}
                                 label="Father's Name"
                                 rules={[{ required: disabled ? false : true, message: "Father's is required" },]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.fathers_name : null}
                              >
                                 <Input id={'fathers_name'} name={'fathers_name'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'fathers_mobile'}
                                 label="Mobile No."
                                 rules={[
                                    { required: disabled ? false : true, message: 'Mobile No. is required' },
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid mobile number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.fathers_mobile : null}
                              >
                                 <Input id={'fathers_mobile'} name={'fathers_mobile'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'fathers_email_add'}
                                 label="E-Mail Address"
                                 rules={[
                                    { required: disabled ? false : true, message: 'E-Mail Address is required' },
                                    { type: 'email', message: 'Please enter a valid email address' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.fathers_email_add : null}
                              >
                                 <Input id={'fathers_email_add'} name={'fathers_email_add'} style={{ borderRadius: '7px' }} type="email" disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'mothers_name'}
                                 label="Mothers's Name"
                                 rules={[{ required: disabled ? false : true, message: "Mothers's is required" },]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.mothers_name : null}
                              >
                                 <Input id={'mothers_name'} name={'mothers_name'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'mothers_mobile'}
                                 label="Mobile No."
                                 rules={[
                                    { required: disabled ? false : true, message: 'Mobile No. is required' },
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid mobile number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.mothers_mobile : null}
                              >
                                 <Input id={'mothers_mobile'} name={'mothers_mobile'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'mothers_email_add'}
                                 label="E-Mail Address"
                                 rules={[
                                    { required: disabled ? false : true, message: 'E-Mail Address is required' },
                                    { type: 'email', message: 'Please enter a valid email address' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.mothers_email_add : null}
                              >
                                 <Input id={'mothers_email_add'} name={'mothers_email_add'} style={{ borderRadius: '7px' }} type="email" disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={6} lg={6}>
                              <Form.Item
                                 name={'legal_guardian_name'}
                                 label="Legal Guardian (if applicable)"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.legal_guardian_name : null}
                              >
                                 <Input id={'legal_guardian_name'} name={'legal_guardian_name'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={6} lg={6}>
                              <Form.Item
                                 name={'legal_guardian_relationship'}
                                 label="Relationship to Student"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.legal_guardian_relationship : null}
                              >
                                 <Input id={'legal_guardian_relationship'} name={'legal_guardian_relationship'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={6} lg={6}>
                              <Form.Item
                                 name={'legal_guardian_mobile_no'}
                                 label="Mobile No."
                                 rules={[
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid phone number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.legal_guardian_mobile_no : null}
                              >
                                 <Input id={'legal_guardian_mobile_no'} name={'legal_guardian_mobile_no'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={6} lg={6}>
                              <Form.Item
                                 name={'legal_guardian_email'}
                                 label="E-Mail Address"
                                 rules={[
                                    { type: 'email', message: 'Please enter a valid email address' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.legal_guardian_email : null}
                              >
                                 <Input id={'legal_guardian_email'} name={'legal_guardian_email'} style={{ borderRadius: '7px' }} type="email" disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                           <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>PERSON(S) AUTHORIZED TO PICK UP THE STUDENT IN CASE OF EMERGENCY</Title>
                        </Divider>

                        <Row gutter={12}>
                           <Col xs={24} sm={24} md={24} lg={24}>
                              <h6>(Other than parents/guardian. Must present valid ID upon pick-up)</h6>
                           </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_1'}
                                 label="Name"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_1 : null}
                              >
                                 <Input id={'autorized_person_1'} name={'autorized_person_1'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_1_relationship'}
                                 label="Relationship to Student"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_1_relationship : null}
                              >
                                 <Input id={'autorized_person_1_relationship'} name={'autorized_person_1_relationship'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_1_contact_no'}
                                 label="Contact No."
                                 rules={[
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid phone number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_1_contact_no : null}
                              >
                                 <Input id={'autorized_person_1_contact_no'} name={'autorized_person_1_contact_no'} style={{ borderRadius: '7px' }} type="tel" maxLength={20} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_2'}
                                 label="Name"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_2 : null}
                              >
                                 <Input id={'autorized_person_2'} name={'autorized_person_2'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_2_relationship'}
                                 label="Relationship to Student"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_2_relationship : null}
                              >
                                 <Input id={'autorized_person_2_relationship'} name={'autorized_person_2_relationship'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_2_contact_no'}
                                 label="Contact No."
                                 rules={[
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid phone number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_2_contact_no : null}
                              >
                                 <Input id={'autorized_person_2_contact_no'} name={'autorized_person_2_contact_no'} style={{ borderRadius: '7px' }} type="tel" maxLength={20} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_3'}
                                 label="Name"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_3 : null}
                              >
                                 <Input id={'autorized_person_3'} name={'autorized_person_3'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_3_relationship'}
                                 label="Relationship to Student"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_3_relationship : null}
                              >
                                 <Input id={'autorized_person_3_relationship'} name={'autorized_person_3_relationship'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'autorized_person_3_contact_no'}
                                 label="Contact No."
                                 rules={[
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid phone number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.autorized_person_3_contact_no : null}
                              >
                                 <Input id={'autorized_person_3_contact_no'} name={'autorized_person_3_contact_no'} style={{ borderRadius: '7px' }} type="tel" maxLength={20} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                           <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>MEDICAL INFORMATION</Title>
                        </Divider>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'allergies'}
                                 label="Allergies (food/medicine)"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.allergies : null}
                              >
                                 <Input id={'allergies'} name={'allergies'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'medical_conditions'}
                                 label="Existing Medical Conditions"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.medical_conditions : null}
                              >
                                 <Input id={'medical_conditions'} name={'medical_conditions'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'medications'}
                                 label="Medications Taken Regularly"
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.medications : null}
                              >
                                 <Input id={'medications'} name={'medications'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        <Divider orientation="left" style={{ paddingBottom: '10px', paddingTop: '10px', borderTopColor: '#ccc', margin: '0px 0px' }}>
                           <Title level={5} style={{ textAlign: "Left", color: '#1B5596' }}>EMERGENCY CONTACT(if parents/guardians cannot be reached)</Title>
                        </Divider>

                        <Row gutter={[12, 12]}>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'emergency_contact_name'}
                                 label="Name"
                                 rules={[
                                    { required: disabled ? false : true, message: 'Name is required' },
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.emergency_contact_name : null}
                              >
                                 <Input id={'emergency_contact_name'} name={'emergency_contact_name'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'emergency_contact_relationship'}
                                 label="Relationship to Student"
                                 rules={[
                                    { required: disabled ? false : true, message: 'Relationship is required' },
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.emergency_contact_relationship : null}
                              >
                                 <Input id={'emergency_contact_relationship'} name={'emergency_contact_relationship'} style={{ borderRadius: '7px' }} disabled={disabled} />
                              </Form.Item>
                           </Col>
                           <Col xs={24} sm={24} md={8} lg={8}>
                              <Form.Item
                                 name={'emergency_contact_number'}
                                 label="Contact No."
                                 rules={[
                                    { required: disabled ? false : true, message: "Contact No. is required" },
                                    { pattern: /^[0-9\-+()\s]*$/, message: 'Please enter a valid phone number' }
                                 ]}
                                 style={{ marginBottom: '10px' }}
                                 initialValue={emergencyInfo !== null ? emergencyInfo.emergency_contact_number : null}
                              >
                                 <Input id={'emergency_contact_number'} name={'emergency_contact_number'} style={{ borderRadius: '7px' }} type="tel" maxLength={20} disabled={disabled} />
                              </Form.Item>
                           </Col>
                        </Row>

                        {disabled ? (
                           <></>
                        ) : (
                           <>
                              <Divider orientation="left" style={{ padding: '10px 0', borderTopColor: '#ccc', margin: 0 }}>
                                 <Title level={5} style={{ textAlign: 'left', color: '#1B5596' }}>ACKNOWLEDGEMENT</Title>
                              </Divider>

                              <Row gutter={[12, 12]} justify="center">
                                 <Col span={24}>
                                    <p className="emergency-info-acknowledgement">
                                       I hereby certify that the information provided above is true and accurate. I understand that this data will be used by {oaData.school_name} for student safety, emergency response, and communication purposes in accordance with DepEd DRRM directives and RA 10173 (Data Privacy Act of 2012)
                                    </p>
                                 </Col>
                                 <Col span={24} className="emergency-info-save-row">
                                    <Button className='button-shadow emergency-info-save-btn' type='primary' onClick={handleSubmit} shape='round' htmlType="submit" icon={<SaveOutlined />}>
                                       Save Emergency Info
                                    </Button>
                                 </Col>
                              </Row>
                           </>
                        )}

                     </Form>
                     </section>
                  </>
               )}
            </div>
         </div>

         <Modal
            key='disclaimer'
            title={"Privacy Statement"}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={modalDisclaimer}
            width='50%'
            onCancel={() => { setModalDisclaimer(false); }}
            onOk={() => { setModalDisclaimer(false); }}
         >
            <div className='essay_list_container' style={{ background: "#fff" }}>

            </div>
         </Modal>
      </>
   )
}
